export default __webpack_public_path__ + "static/media/Invoice-amico1.2b74de05.png";